export default "__VITE_ASSET__CY1Y90iO__"